module.exports = __webpack_public_path__ + "media/images/emblems/Hergiswil-coat_of_arms-609f458122b9a21f102409fcd805df8b.svg";